import { headerAuthorization } from '../../../shared/helpers/localstorage-helper';
import { ConfigsTests } from '../../../shared/types/configs-tests';
import { BASE_URL } from '../../../shared/consts/variables';

export const getConfigurationsTests = async () => {
    const response = await fetch(`${BASE_URL}/configurations-tests`, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            ...headerAuthorization()
        }
    });

    if (!response.ok) {
        const error = await response.json();
        throw new Error(error.message || 'Erro ao buscar dados do usuário');
    }

    return response.json();
}

export const postConfigurationsTests = async (configsTests: ConfigsTests) => {
    const response = await fetch(`${BASE_URL}/configurations-tests`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            ...headerAuthorization()
        },
        body: JSON.stringify(configsTests)
    });

    if (!response.ok) {
        const error = await response.json();
        throw new Error(error.message || 'Erro ao buscar dados do usuário');
    }

    return response.json();
}

export const deleteConfigurationsTests = async (id: string) => {
    const response = await fetch(`${BASE_URL}/configurations-tests/${id}`, {
        method: 'DELETE',
        headers: {
            'Content-Type': 'application/json',
            ...headerAuthorization()
        }
    });

    if (!response.ok) {
        const error = await response.json();
        throw new Error(error.message || 'Erro ao buscar dados do usuário');
    }

    return response.json();
}

export const updateConfigurationsTests = async (configsTests: ConfigsTests) => {
    const response = await fetch(`${BASE_URL}/configurations-tests/${configsTests.id}`, {
        method: 'PUT',
        headers: {
            'Content-Type': 'application/json',
            ...headerAuthorization()
        },
        body: JSON.stringify(configsTests)
    });

    if (!response.ok) {
        const error = await response.json();
        throw new Error(error.message || 'Erro ao buscar dados do usuário');
    }

    return response.json();
}

export const getConfigurationsTestsByCompanyId = async (id: string) => {
    const response = await fetch(`${BASE_URL}/configurations-tests/company/${id}`, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            ...headerAuthorization()
        }
    });

    if (!response.ok) {
        const error = await response.json();
        throw new Error(error.message || 'Erro ao buscar dados do usuário');
    }

    return response.json();
}

export const getConfigurationTestById = async (id: string) => {
    const response = await fetch(`${BASE_URL}/configurations-tests/${id}`, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            ...headerAuthorization()
        }
    });

    if (!response.ok) {
        const error = await response.json();
        throw new Error(error.message || 'Erro ao buscar dados do usuário');
    }

    return response.json();
}
    